<template>
  <div class="picktime">
    <a-date-picker @change="onChange(1, $event)" valueFormat="YYYY-MM-DD" format='YYYY-MM-DD' v-model="stime"
      @clearTime="clearTime" style="width:48%;" placeholder="开始时间" :size="size" />
    <span class="h">—</span>
    <a-date-picker @clearTime="clearTime" @change="onChange(2, $event)" valueFormat="YYYY-MM-DD" format='YYYY-MM-DD'
      v-model="etime" style="width:48%;" placeholder="结束时间" :size="size" />
  </div>
</template>
<script>
export default {
  props: {
    now: '',
    size: {
      type: String,
      default() {
        return 'default'
      }
    }
  },
  data() {
    return {
      stime: '',
      etime: ''
    }
  },
  watch: {
    now: {
      handler(newVal) {
        if (newVal) {
          this.stime = newVal;
          this.etime = newVal;
          // 可选：如果需要通知父组件时间已更新，可以添加
          this.$emit("PickTime", { stime: newVal, etime: this.etime })
        }
      },
      immediate: true
    }
  },
  created() {

  },
  methods: {
    clearTime() {
      this.stime = ''
      this.etime = ''
      // 可选：如果需要通知父组件时间已清空，可以添加
      this.$emit("PickTime", { stime: '', etime: '' })
    },
    onChange(type, time) {

      let obj = new Object()
      let key = type == 1 ? "stime" : "etime"
      obj[key] = time
      if (type == 2 && this.getMis(this.stime) > this.getMis(time)) {
        this.etime = ''
        obj[key] = ''
      }
      this.$emit("PickTime", obj)
    },
    getMis(date) {
      return new Date(date).getTime()
    }
  }
}
</script>
<style lang="less" scoped>
.picktime {
  display: flex;
  align-items: center;

  .time {
    width: 48%;
  }

  .h {
    color: #dbdcde;
    padding: 0 10px;
    line-height: 30px;
  }
}
</style>